// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-scrollbar__wrap[data-v-ac61fb4a]{width:300px;height:200px}.zhs-no-data .label[data-v-ac61fb4a]{font-size:14px}.sec_banner[data-v-ac61fb4a]{border-radius:0;z-index:1}.banner-item .banner-wrapper[data-v-ac61fb4a],.sec_banner[data-v-ac61fb4a]{width:100%;height:330px}.banner-item .banner-img[data-v-ac61fb4a]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.sec_banner.hiddenSlides[data-v-ac61fb4a] .el-carousel__indicators{display:none}", ""]);
// Exports
module.exports = exports;
